module.exports = __webpack_public_path__ + "static/media/msTeams.f1dc6b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/msTeams.jpg
// module id = 796
// module chunks = 5